import { render, staticRenderFns } from "./LogoPlacement.vue?vue&type=template&id=5784b9fc&scoped=true&"
import script from "./LogoPlacement.vue?vue&type=script&lang=js&"
export * from "./LogoPlacement.vue?vue&type=script&lang=js&"
import style0 from "./LogoPlacement.vue?vue&type=style&index=0&id=5784b9fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5784b9fc",
  null
  
)

export default component.exports